import {Notification} from 'element-ui'

let HxNotify = {

    success(title, message) {
        Notification.success({
            showClose: true,
            title: title,
            message: message,
            type: 'success',
            offset: 100
        })
    },

    warning(title, message) {
        Notification.warning({
            showClose: true,
            title: title,
            message: message,
            type: 'warning',
            offset: 100
        })
    },

    info(title, message) {
        Notification.info({
            showClose: true,
            title: title,
            message: message,
            type: 'info',
            offset: 100
        })
    },

    error(title, message) {
        Notification.error({
            showClose: true,
            title: title,
            message: message,
            type: 'error',
            offset: 100
        })
    }
}

export default HxNotify